import { render, staticRenderFns } from "./AddContactModal.vue?vue&type=template&id=8e0f16fe"
import script from "./AddContactModal.vue?vue&type=script&lang=ts"
export * from "./AddContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports